module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-75.11d54303.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-75.png
// module id = 3338
// module chunks = 11